module.exports = __webpack_public_path__ + "img/pagsmile-v3-color.b882d71.png";